module.exports = __webpack_public_path__ + "img/wm.8dafe0f6.png";